import { Skeleton, Stack } from "@mui/material";

interface ILoadingStateProps {
	useAlternative?: boolean;
}
function LoadingState(props: ILoadingStateProps) {
	const { useAlternative = false } = props;
	return (
		<Stack alignItems={"flex-start"}>
			<Stack direction={"row"} spacing={1} alignItems={"center"}>
				<Skeleton variant={"circular"} width={13} height={13} />
				<Skeleton variant={"text"} width={260} height={20} />
			</Stack>
			{useAlternative ? (
				""
			) : (
				<Skeleton
					variant={"text"}
					width={300}
					height={20}
					sx={{
						marginLeft: "21px",
						marginBottom: "5px",
					}}
				/>
			)}
		</Stack>
	);
}
export default LoadingState;
